<template>
    <div id="header-hero-main" :class="headerImageIsLoaded ? 'not-hidden header-hero-main' : 'hidden header-hero-main'">
        <div class="nav-bar">
            <img class="header-menu-logo" src="@/assets/graphics/don_friso_logo.png" />
            <div class="header-menu-text-wrapper">
                <div v-if="innerWidth < 1100">
                    <p class="header-menu-text paragraph-friso">
                        <a @click="menuClicked()">MENU</a>
                    </p>
                    <div :class="!menuOpen ? 'mobile-menu mobile-menu-collapsed' : 'mobile-menu mobile-menu-expanded'">
                        <p class="header-menu-text paragraph-friso">
                            <a href="#musik">MUSIK</a><br />
                            <a href="#texte">TEXTE</a><br />
                            <a href="#live">LIVE</a><br />
                            <a href="#kontakt">KONTAKT</a><br />
                        </p>
                    </div>
                </div>
                <p v-else class="header-menu-text paragraph-friso">
                    <a href="#musik">MUSIK</a><br />
                    <a href="#texte">TEXTE</a><br />
                    <a href="#live">LIVE</a><br />
                    <a href="#kontakt">KONTAKT</a><br />
                </p>
            </div>
        </div>

        <div class="hero-content">
            <div class="hero-left">
                <img id="header-hero-img" @load="headerImageLoaded()" src="@/assets/img/Don_Friso_faded_min.png" />
            </div>

            <div class="hero-right">
                <h2 class="welcome-title">Härzlech wellkomme!</h2>
                <p class="welcome-intro">Schön besch done glandet 🛸. Do fensch Gig-Date, Text ond es paar Sneak-Peaks vo Videos. Falls wetsch öber Don Friso informiert bilbe, gets zodem di folgende Möglechkeite. Ech freue mech uf dech!</p>

                <div class="info-card">
                    <h3 class="card-title">Don Friso Live Ticker</h3>
                    <p class="card-text">En Whatsapp-Gruppe met allne Gigs ond Releases. Ca. 1 mol im Monet. One-Way Chat ohni Diskussione.</p>
                    <a href="https://chat.whatsapp.com/BtMlI0B9nBrKJ1yo8tGxE0?mode=gi_t" target="_blank" class="welcome-btn">Jetzt biträtte</a>
                </div>

                <div class="info-card">
                    <h3 class="card-title">Persönlechi Nochrechte</h3>
                    <p class="card-text">Du chasch mer dörögäh, wie du wetsch Neuigkeite becho: Per Whatsapp, Telegram, Email...? Schrib mer doch eifach oder lüt ah: 079 530 48 72</p>
                    <div class="card-btn-row">
                        <a href="https://wa.me/41795304872" target="_blank" class="welcome-btn">Jetzt per Whatsapp chatte</a>
                        <a href="tel:+41795304872" class="welcome-btn">Jetzt alüte</a>
                    </div>
                </div>

                <div class="info-card">
                    <h3 class="card-title">Socials</h3>
                    <p class="card-text">Alli Social-Links fendsch grad do ondedra.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HeroHeader',
    data() {
        return {
            innerWidth: window.innerWidth,
            menuOpen: false,
            headerImageIsLoaded: false,
        };
    },
    mounted() {
        window.addEventListener("resize", this.screenSizeChanged);
    },
    unmounted() {
        window.removeEventListener("resize", this.screenSizeChanged);
    },
    methods: {
        headerImageLoaded() {
            this.headerImageIsLoaded = true;
        },
        menuClicked() {
            this.menuOpen = !this.menuOpen;
        },
        screenSizeChanged() {
            this.innerWidth = window.innerWidth;
        }
    }
}
</script>

<style scoped>
a {
    text-decoration: none;
    color: white;
}

.header-hero-main {
    transition: all 3s ease;
}

.not-hidden {
    opacity: 1;
}

.hidden {
    opacity: 0;
}

/* Nav bar */
.nav-bar {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0 20px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
}

.header-menu-logo {
    width: min(60vw, 300px);
}

.header-menu-text-wrapper {
    text-align: right;
    margin-top: 10px;
}

.header-menu-text {
    color: white;
    font-weight: medium;
    font-size: x-large;
}

.header-menu-text > a {
    cursor: pointer;
    transition: color 0.5s ease;
}

.header-menu-text > a:hover {
    color: var(--achterbahn-color);
    transition: color 0.5s ease;
}

.mobile-menu {
    transition: max-height 1s ease-in-out, opacity 0.75s ease-in-out;
    overflow: hidden;
}

.mobile-menu-collapsed {
    max-height: 0px;
    opacity: 0;
}

.mobile-menu-expanded {
    max-height: 600px;
    opacity: 1;
}

/* Two-column hero content */
.hero-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 100vh;
    padding-top: 80px;
}

.hero-left {
    display: flex;
    justify-content: center;
    align-items: center;
}

#header-hero-img {
    width: min(90vw, 500px);
    mask-image: linear-gradient(180deg, rgba(0, 0, 0, 1) 20%, rgba(0, 0, 0, 0));
    filter: brightness(1.12);
}

.hero-right {
    width: min(90vw, 500px);
    text-align: left;
    padding: 20px 0 60px 0;
}

/* Welcome text */
.welcome-title {
    color: white;
    font-weight: bold;
    font-size: x-large;
    text-transform: uppercase;
    margin-bottom: 12px;
    margin-top: 0;
}

.welcome-intro {
    color: white;
    font-size: medium;
    text-transform: none;
    margin-bottom: 24px;
    line-height: 1.5;
}

/* Cards */
.info-card {
    border: 1px solid white;
    padding: 20px;
    margin-bottom: 14px;
}

.card-title {
    color: white;
    font-weight: bold;
    font-size: medium;
    text-transform: uppercase;
    margin: 0 0 10px 0;
}

.card-text {
    color: white;
    font-size: small;
    text-transform: none;
    line-height: 1.5;
    margin: 0 0 14px 0;
}

/* Buttons */
.welcome-btn {
    display: inline-block;
    border: 1px solid white;
    color: white;
    padding: 8px 16px;
    font-family: var(--font-family);
    font-size: small;
    text-transform: uppercase;
    background: transparent;
    cursor: pointer;
    transition: background 0.3s ease, color 0.3s ease;
    text-decoration: none;
    margin-top: 4px;
}

.welcome-btn:hover {
    background: white;
    color: black;
}

.card-btn-row {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

/* Desktop */
@media only screen and (min-width: 1100px) {
    .hero-content {
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 60px;
        padding-top: 0;
    }

    .hero-left {
        flex: 0 0 auto;
    }

    #header-hero-img {
        width: 480px;
    }

    .hero-right {
        flex: 0 0 auto;
        width: 420px;
        padding: 120px 0 60px 0;
    }

    .welcome-title {
        font-size: xx-large;
    }
}
</style>
